import type { DormantSoftwareQuery } from './type';
export const dormancyKey = {
  all: ['accesses', 'dormancy'] as const,
  config: () => [...dormancyKey.all, 'config'] as const,
  summary: () => [...dormancyKey.all, 'summary'] as const,
  lists: () => [...dormancyKey.all, 'software', 'list'] as const,
  list: (params: DormantSoftwareQuery) => [...dormancyKey.lists(), params] as const
} as const;